import { Component, ViewContainerRef, ViewEncapsulation } from '@angular/core';

import { GlobalState } from './global.state';
import {
  BaImageLoaderService,
  BaThemePreloader,
  BaThemeSpinner,
} from './theme/services';
import { BaThemeConfig } from './theme/theme.config';
import { layoutPaths } from './theme/theme.constants';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
//import 'style-loader!./app.scss';
//import 'style-loader!./theme/initial.scss';

/*
 * App Component
 * Top Level Component
 */
// declare function resizableGrid(): void;
@Component({
  selector: 'app',
  template: `
    <main [ngClass]="{ 'menu-collapsed': isMenuCollapsed }" baThemeRun>
      <div class="additional-bg"></div>
      <router-outlet></router-outlet>
    </main>
  `,
  styleUrls: [
    './app.scss',
    './theme/initial.scss',
    './theme/components/baSidebar/baSidebar.scss',
  ],
  encapsulation: ViewEncapsulation.None,
})
export class App {
  isMenuCollapsed: boolean = false;

  constructor(
    private _state: GlobalState,
    private _imageLoader: BaImageLoaderService,
    private _spinner: BaThemeSpinner,
    private viewContainerRef: ViewContainerRef,
    private themeConfig: BaThemeConfig,
    private http: HttpClient
  ) {
    themeConfig.config();

    this._loadImages();
    // resizableGrid();

    // this._state.subscribe('menu.isCollapsed', (isCollapsed: boolean) => {
    //   this.isMenuCollapsed = isCollapsed;
    // });
    this._state.subscribe('menu.isCollapsed', (value: any) => {
      this.isMenuCollapsed = value['menu.isCollapsed'];
      //this.isMenuCollapsed = isCollapsed;
      console.log({
        appsubscriptionReceived: 'menu.iscollapsed',
        value: value,
        isMenuCollapsed: value['menu.isCollapsed'],
      });
    });
    this.http.get('/assets/appConfig.json').subscribe(
      (data: any) => {
        this._state.setGlobalSetting('apiUrl', [data.apiUrl]);
      },
      (error: any) => {
        alert(error);
        this._state.setGlobalSetting('apiUrl', ['https://localhost:44396/api']);
      }
    );
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  private _loadImages(): void {
    // register some loaders
    BaThemePreloader.registerLoader(
      this._imageLoader.load(layoutPaths.images.root + 'sky-bg.jpg')
    );
  }
}
